// extracted by css-extract-rspack-plugin
export default {"LinearAxis":"LinearAxis--YvL2Z"};